import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NineBoxesServices from "./NineBoxes.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNineBoxes = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_NINE_BOXES,
      payload: true,
    });
    const resp = await NineBoxesServices.getNineBoxes(filters);
    let employees = [];
    if (resp.data && resp.data.resultado) {
      resp.data.resultado.map((item) => {
        employees = employees.concat(item.empleados);
      });
    }
    let divisions = [];
    employees.map((item) => {
      if (!divisions.find((t) => t.id === item.division_personal_id)) {
        divisions.push(item.division_List);
      }
    });
    dispatch({
      type: actions.GET_NINE_BOXES,
      payload: {
        nineBoxes: { data: resp.data.resultado },
        potencial_promedio: resp.data.potencial_promedio,
        desempenio_promedio: resp.data.desempenio_promedio,
        employees: employees,
        divisions: divisions,
      },
    });
    dispatch({
      type: actions.NINE_BOXES_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.resultado) {
              message = ex.response.data.resultado;
            } else {
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else if (ex.response.data && ex.response.data.resultado) {
              message = ex.response.data.resultado;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.NINE_BOXES_FALLA,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_NINE_BOXES,
      payload: false,
    });
  }
};
